import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { BiUploadView } from '@euler/model/bi/upload';
import { memo } from 'react';
import { View } from 'react-native';
import { SheetRow } from './SheetRow';

/** A file that failed with its sheets read: each sheet and why. */
export const BlockedSheets = memo(({ view }: { view: BiUploadView }) => {
  const { rpx } = useResponsiveContext();
  if (!view.sheets.length) return null;
  return (
    <View style={{ gap: rpx(8) }}>
      {view.sheets.map(sheet => (
        <SheetRow
          key={sheet.name}
          sheet={sheet}
          rowLimit={view.rowLimit}
          selected={false}
          disabled
          onToggle={() => undefined}
        />
      ))}
    </View>
  );
});
